import React from "react";
import styled from "styled-components";
import Button from "./buttons/button";
import { useLocation, useNavigate } from "react-router";
import { AddRounded, WebRounded, AccountCircle, Logout } from "@mui/icons-material";
import { useUser, useClerk, SignedIn, SignedOut } from "@clerk/clerk-react";

const Container = styled.div`
  flex: 1;
  background: ${({ theme }) => theme.navbar};
  color: ${({ theme }) => theme.menu_primary_text};
  font-weight: bold;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 50px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  @media only screen and (max-width: 600px) {
    padding: 10px 12px;
  }
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${({ theme }) => theme.text_primary};
  font-size: 14px;
`;

const AuthButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useUser();
  const { signOut } = useClerk();

  let path = location.pathname.split("/");

  const gotoCreatePost = () => {
    navigate("/post");
  };
  const gottoHome = () => {
    navigate("/");
  };
  const gotoSignIn = () => {
    navigate("/sign-in");
  };
  const gotoSignUp = () => {
    navigate("/sign-up");
  };

  const handleSignOut = () => {
    signOut();
    navigate("/");
  };

  return (
    <Container>
      ImagineAI
      <UserSection>
        <SignedIn>
          <UserInfo>
            <AccountCircle style={{ fontSize: "20px" }} />
            <span>{user?.firstName || user?.emailAddresses[0]?.emailAddress}</span>
          </UserInfo>
          {path[1] === "post" ? (
            <Button
              text="Explore Posts"
              leftIcon={<WebRounded style={{ fontSize: "18px" }} />}
              onClick={gottoHome}
              type="secondary"
            />
          ) : (
            <Button
              text="Create new post"
              leftIcon={<AddRounded style={{ fontSize: "18px" }} />}
              onClick={gotoCreatePost}
            />
          )}
          <Button
            text="Sign Out"
            leftIcon={<Logout style={{ fontSize: "18px" }} />}
            onClick={handleSignOut}
            type="secondary"
          />
        </SignedIn>
        <SignedOut>
          <AuthButtons>
            <Button
              text="Sign In"
              onClick={gotoSignIn}
              type="secondary"
            />
            <Button
              text="Sign Up"
              onClick={gotoSignUp}
            />
          </AuthButtons>
          {path[1] === "post" ? (
            <Button
              text="Explore Posts"
              leftIcon={<WebRounded style={{ fontSize: "18px" }} />}
              onClick={gottoHome}
              type="secondary"
            />
          ) : (
            <Button
              text="Create new post"
              leftIcon={<AddRounded style={{ fontSize: "18px" }} />}
              onClick={gotoCreatePost}
            />
          )}
        </SignedOut>
      </UserSection>
    </Container>
  );
};

export default Navbar;
